import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Switches = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M9.89998188,4 L19,4 C19.5522847,4 20,4.44771525 20,5 C20,5.55228475 19.5522847,6 19,6 L9.89998188,6 C9.43671155,8.28224032 7.41895791,10 5,10 C2.23857625,10 0,7.76142375 0,5 C0,2.23857625 2.23857625,0 5,0 C7.41895791,0 9.43671155,1.71775968 9.89998188,4 Z M5,8 C6.65685425,8 8,6.65685425 8,5 C8,3.34314575 6.65685425,2 5,2 C3.34314575,2 2,3.34314575 2,5 C2,6.65685425 3.34314575,8 5,8 Z M10.1000181,14 C10.5632884,11.7177597 12.5810421,10 15,10 C17.7614237,10 20,12.2385763 20,15 C20,17.7614237 17.7614237,20 15,20 C12.5810421,20 10.5632884,18.2822403 10.1000181,16 L1,16 C0.44771525,16 0,15.5522847 0,15 C0,14.4477153 0.44771525,14 1,14 L10.1000181,14 Z M15,18 C16.6568542,18 18,16.6568542 18,15 C18,13.3431458 16.6568542,12 15,12 C13.3431458,12 12,13.3431458 12,15 C12,16.6568542 13.3431458,18 15,18 Z"
				id="switches"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Switches.propTypes = {
	color: PropTypes.string,
};

export default Switches;
